<template>
  <div class="bg">
    <div class="content">
      <div class="page-header">
        <el-page-header @back="goBack"></el-page-header>
        <span id="header-title">账号信息</span>
      </div>
      <div class="main">
        <el-tabs type="card" :tab-position=" 'left' " class="tabs">
          <el-tab-pane label="用户信息">
            <div class="info" style="padding-top: 15vh">
              <div class="info-item" v-for="(item,index) in attribute" :key="index">
                <div class="attribute-name">{{item.label}}：</div>
                <div class="attribute-value">{{user[item.name]}}</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="修改密码">
            <div class="info" style="padding-top: 20vh">
              <div class="info-item">
                <div class="attribute-name">原密码：</div>
                <el-input v-model="input1" placeholder="请输入原密码" show-password></el-input>
                <div class="empty-warning" id="empty-warning1">此为必填项！</div>
              </div>
              <div class="info-item">
                <div class="attribute-name">新密码：</div>
                <el-input v-model="input2" placeholder="请输入新密码" show-password></el-input>
                <div class="empty-warning" id="empty-warning2">此为必填项！</div>
              </div>
              <div class="info-item">
                <div class="attribute-name">确认新密码：</div>
                <el-input v-model="input3" placeholder="请确认新密码" show-password></el-input>
                <div class="empty-warning" id="empty-warning3">此为必填项！</div>
              </div>
              <el-button>重置</el-button>
              <el-button type="primary" @click="nullCheck">提交</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'account',
    data() {
      return {
        input1: '',
        input2: '',
        input3: '',
        attribute: [
          {
            name: 'username',
            label: '用户名'
          },
          {
            name: 'email',
            label: '邮箱'
          },
          {
            name: 'company_name',
            label: '公司名'
          },
          {
            name: 'search_time',
            label: '检索次数'
          },
          {
            name: 'download_time',
            label: '下载次数'
          },
          {
            name: 'expiration_date',
            label: '到期时间'
          }
        ],
        user: {
          username: "manager1",
          email: "564785000@gmail.com",
          company_name: "",
          search_time: "26/50000",
          download_time: "4/50000",
          expiration_date: "2027-12-08"
        }
      }
    },
    mounted: function () {},
    methods: {
      goBack() {
        window.history.back();
      },
      nullCheck() {
        var e1 = document.getElementById("empty-warning1");
        var e2 = document.getElementById("empty-warning2");
        var e3 = document.getElementById("empty-warning3");
        if(this.input1 == ''){
          e1.style.visibility = "visible";
        }else{
          e1.style.visibility = "hidden";
        }
        if(this.input2 == ''){
          e2.style.visibility = "visible";
        }else{
          e2.style.visibility = "hidden";
        }
        if(this.input3 == ''){
          e3.style.visibility = "visible";
        }else{
          e3.style.visibility = "hidden";
        }
      }
    }
  }
</script>

<style scoped>
  .bg {
    background-color: #f7faff;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
  .content{
    width: calc(100% - 400px);
    max-width: 1920px;
    height: calc(100vh - 48px);
    flex-direction: column;
    margin: 0 200px 0 200px;
  }

  .page-header {
    height: 49px;
    width: 100%;
    border-bottom: 1px solid #e5e6eb;
  }
  .el-page-header {
    padding-top: 10px;
    width: 94px;
    float: left;
  }
  .page-header #header-title {
    font-size: 18px;
    font-weight: bold;
    float: left;
    margin: 9px 40px 0 0;
  }

  .main {
    overflow: auto;
    height: calc(100% - 80px);
    width: 100%;
    padding-top: 30px;
  }
  .info {
    margin: 0 auto;
    text-align: center;
  }

  .info-item {
    width: calc(100% - 120px);
    padding: 4px 60px 4px 60px;
  }
  .attribute-name{
    display: inline-block;
    vertical-align: top;
    width: 120px;
    text-align: right;
    padding-right: 30px;
    color: #959595;
    font-weight: bold;
    line-height:40px;
    font-size: 14px;
  }
  .attribute-value{
    display: inline-block;
    vertical-align: top;
    line-height: 150%;
    width: calc(100% - 600px);
    border-bottom: 1px dashed #e5e6eb;
    line-height:40px;
    font-size: 14px;
  }
  .info .el-input {
    width: 300px;
  }
  .info .el-button {
    margin: 30px 0 0 20px;
  }
  .empty-warning {
    font-size: 14px;
    color: #F46C6C;
    display: inline-block;
    padding-left: 20px;
    visibility: hidden;
  }
</style>
